<table mat-table [dataSource]="documents" style="z-index: 0;" matSort (matSortChange)="onSortChange($event)">
  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      <mat-checkbox (change)="$event ? toggleAllRows() : null" color="primary"
        [checked]="hasPageSelection() && isAllSelected()" [indeterminate]="hasPageSelection() && !isAllSelected()">
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let row">
      <mat-checkbox (click)="$event.stopPropagation()" color="primary" (change)="$event ? toggle(row) : null"
        [checked]="isSelected(row)">
      </mat-checkbox>
    </td>
  </ng-container>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <span class="upper small light bold">
        {{'DOCUMENT.NAME' | translate}}
      </span>
    </th>
    <td mat-cell *matCellDef="let document">
      <div class="fx-row align-items-center justify-content-start">
        <img [src]="documentIcon(document)" [height]="35" class="mr-10" />
        <div class="fx-column name-container">
          <span class="text bold name">{{document?.name || '-'}}</span>
        </div>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="class">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <span class="upper small light bold">
        {{'DOCUMENT.CLASS' | translate}}
      </span>
    </th>
    <td mat-cell *matCellDef="let document">
      <span class="text">{{document.class ? ('DOCUMENT_CLASSES.'+document.class.toUpperCase() | translate) :
        '-'}}</span>
    </td>
  </ng-container>
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef>
      <span class="upper small light bold">
        {{'DOCUMENT.STATUS' | translate}}
      </span>
    </th>
    <td mat-cell *matCellDef="let document">
      <div class="fx-row align-items-center justify-content-start">
        <mat-icon class="mr-5" [class]="getDocumentStatus(document).class" fontSet="material-icons-outlined"
          [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="getDocumentStatus(document).tooltip">info</mat-icon>
        <span class="text">{{getDocumentStatus(document).label}}</span>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>
    </th>
    <td mat-cell *matCellDef="let document">
      <button mat-icon-button>
        <mat-icon class="main" fontSet="material-icons-outlined">navigate_next</mat-icon>
      </button>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="clickable" (click)="toDocument(row)">
  </tr>
</table>
<mat-paginator
  [length]="pager.totalDocs || 0" [pageSize]="pager.limit || 0" [pageIndex]="pager.page - 1 || 0"
  [pageSizeOptions]="[10, 25, 50, 100]" (page)="handlePage($event)">
</mat-paginator>
